import { PreloadedQuery as BasePreloadedQuery, GraphQLTaggedNode, usePreloadedQuery } from 'react-relay';
import { OperationType } from 'relay-runtime';

type Props<TQuery extends OperationType> = {
  query: GraphQLTaggedNode;
  queryReference: BasePreloadedQuery<TQuery>;
  children: (data: TQuery['response']) => React.ReactNode;
};

const PreloadedQueryRenderer = <TQuery extends OperationType>({ query, queryReference, children }: Props<TQuery>) => {
  const data = usePreloadedQuery(query, queryReference);

  return children(data) as JSX.Element;
};

export default PreloadedQueryRenderer;
export type { Props as PreloadedQueryRendererProps };
